module.exports = __webpack_public_path__ + "img/sub_support_3.9f5c8e4b.png";